import { useState, useCallback } from 'react';

const useLoadMoreList = (initialPerPage = 5, step = 5) => {
    const [perPage, setPerPage] = useState(initialPerPage);

    const handleLoadMore = useCallback(() => {
        setPerPage(prev => prev + step);
    }, [step]);

    const handleShowLess = useCallback(() => {
        setPerPage(prev => Math.max(initialPerPage, prev - step));
    }, [initialPerPage, step]);

    return {
        perPage,
        handleLoadMore,
        handleShowLess,
    };
};

export default useLoadMoreList;
